import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { ConfiguracionService } from '../../../../services/configuracion.service';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-fetq-new-edit',
    templateUrl: './new-edit.component.html'
})
export class FormatosEtiquetaNewEditComponent implements OnInit {

    public newEditForm: UntypedFormGroup;
    public archivoForm: UntypedFormGroup;

    public showError = false;
    public mensajes = new Array<Message>();

    public deleteModal = false;
    public updateModal = false;

    private _editable: boolean;

    public _formatoEtiqueta;
    public formatoEtiquetaId;

    public disabledConfiguracion: Subject<boolean> = new Subject();
    public disabledGrados: Subject<boolean> = new Subject();
    public disabledTextos: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledConfiguracion.next(false);
                this.disabledGrados.next(false);
                this.disabledTextos.next(false);
            } else {
                this.newEditForm.disable();
                this.disabledConfiguracion.next(true);
                this.disabledGrados.next(true);
                this.disabledTextos.next(true);
                this.newEditForm.patchValue({
                    nombre: this.formatoEtiqueta.des,
                    configuracion: this.configuraciones.find(x => x.id === this.formatoEtiqueta.configuracionFormatoEtiquetaId),
                });
            }
        }
    }

    @Input() configuraciones;
    @Input() grupoEtiquetaId;
    @Input() formatoEtiqueta?;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();


    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _configuracionService: ConfiguracionService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            nombre: [{ value: '', disabled: !this.editable }, Validators.required],
            configuracion: [{ value: '', disabled: !this.editable }, Validators.required]
        });

        this.archivoForm = this._fb.group({
            archivo: [[{ value: '', disabled: true }], Validators.required],
            refArchivo: [[{ value: '', disabled: true }], Validators.required]
        });

        if (this.formatoEtiqueta) {
            this.newEditForm.patchValue({
                nombre: this.formatoEtiqueta.des,
                configuracion: this.configuraciones.find(x => x.id === this.formatoEtiqueta.configuracionFormatoEtiquetaId),
            });
            this.newEditForm.disable();
            this.disabledConfiguracion.next(true);
            this.disabledGrados.next(true);
            this.disabledTextos.next(true);
        }
    }

    public cancel() {
        this.newEditForm.reset();
        this.editableChanged.emit(false);
        this.close.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.formatoEtiqueta) {
            const formatoEtiqueta = {
                des: this.newEditForm.get('nombre').value,
                grupoEtiquetaId: this.grupoEtiquetaId,
                configuracionFormatoEtiquetaId: this.newEditForm.get('configuracion').value.id
            };
            this._spinnerService.showSpinner();
            this._configuracionService.createFormatoEtiqueta(formatoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.editableChanged.emit(false);
                    this.newEditForm.disable();
                    this.disabledConfiguracion.next(true);
                    this.pushMessage.emit('global.success.itemCreated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        } else if (this.newEditForm.valid && this.formatoEtiqueta) {
            const formatoEtiqueta = {
                id: this.formatoEtiqueta.id,
                des: this.newEditForm.get('nombre').value,
                grupoEtiquetaId: this.grupoEtiquetaId,
                configuracionFormatoEtiquetaId: this.newEditForm.get('configuracion').value.id
            };
            this._spinnerService.showSpinner();
            this._configuracionService.updateFormatoEtiqueta(formatoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.editableChanged.emit(false);
                    this.newEditForm.disable();
                    this.disabledConfiguracion.next(true);
                    this.pushMessage.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    public closeModal() {
        this.deleteModal = false;
    }

    public askDelete(formatoEtiqueta) {
        this.formatoEtiquetaId = formatoEtiqueta.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._configuracionService.deleteFormatoEtiqueta(this.formatoEtiquetaId).toPromise().finally(() => {
        }).then(() => {
            this.closeModal();
            this.refresh.emit(true);
            this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    public edit(formatoEtiqueta) {
        this.newEditForm.enable();
        this.disabledConfiguracion.next(false);
        this.disabledGrados.next(false);
        this.disabledTextos.next(false);
        this.editableChanged.emit(formatoEtiqueta);
    }

    public saveFiles(files: FileList) {
        if (files.length > 1) {
            this.mensajes.push({ class: 'error', message: 'Solo se permite seleccionar un archivo' });
        } else {
            this.convertToBase64(files[0]);
        }
    }

    public onFileChange(event: any) {
        let files: FileList = event.target.files;
        this.saveFiles(files);
    }

    public convertToBase64(file) {
        if (file.name.includes('.nlbl')) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            this._spinnerService.showSpinner();
            reader.onload = () => {
                const archivo = {
                    id: this.formatoEtiqueta.id,
                    archivo: reader.result.toString().replace('data:application/octet-stream;base64,', ''),
                    refArchivo: file.name
                };
                this._configuracionService.asociarFormatoEtiqueta(archivo).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    this.refresh.emit(true);
                    this.pushMessage.emit('Formato Etiqueta Asociado Correctamente');
                    this.showError = true;
                },
                    (error) => {
                        this.showError = true;
                        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                    });
            };
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'Seleccione un archivo con formato .nlbl' });
        }
    }

    public download() {
        let byteString = window.atob(this.formatoEtiqueta.archivo.replace('data:application/octet-stream;base64,', ''));
        let arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
        let int8Array: Uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'application/nlbl' });
        const file = new File([blob], this.formatoEtiqueta.des, { type: 'application/nlbl' });
        saveAs(file, this.formatoEtiqueta.des + '.nlbl');
    }
}
